import React, { useLayoutEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import queryString from 'query-string'
import { renderToStaticMarkup } from 'react-dom/server'
import BlogPostIndexLayout from 'src/components/organisms/blog/BlogPostIndexLayout'
import PardotForm from 'src/components/pardot/PardotForm'

const addIdToHTMLElements = (html) => {
  let tmp = html

  const regexp = /<h2>/
  let id = 1
  while (regexp.test(tmp) && id < 10) {
    tmp = tmp.replace(regexp, `<h2 id="${id}">`)
    id = id + 1
  }

  return tmp
}

const getH2HTMLElementInnerTexts = (html) => {
  const reg = /<h2>.*<\/h2>/g
  let match
  let matches = []
  while ((match = reg.exec(html)) !== null) {
    matches.push(match[0].replace(/(<h2>|<\/h2>)/g, ''))
  }
  return matches
}

const addH2IndexToHTMLText = (html) => {
  const headingTexts = getH2HTMLElementInnerTexts(html)
  const htmlAddedIdForH2 = addIdToHTMLElements(html)

  const htmlWithIndex = htmlAddedIdForH2.replace(
    '[Index]',
    renderToStaticMarkup(<BlogPostIndexLayout headingTexts={headingTexts} />)
  )
  return htmlWithIndex
}

export { addH2IndexToHTMLText }

const addHubspotFormElementToHTMLText = (html) => {
  const htmlWithHubspotElement = html.replace(
    /\[HbsptForm (.*)\]/,
    renderToStaticMarkup(<div id="hubspot" />)
  )

  return htmlWithHubspotElement
}

export { addHubspotFormElementToHTMLText }

const useCreateHbsptForm = (html) => {
  useLayoutEffect(() => {
    const hubspotFormTag = /\[HbsptForm (.*)\]/.exec(html)

    if (!hubspotFormTag) {
      return
    }

    const data = hubspotFormTag[0]
      .replace(/\[(.*)]/, '$1')
      .split(' ')
      .reduce((pre, current) => {
        const keyAndValue = current.split('=')
        if (keyAndValue.length !== 2) {
          return pre
        }

        const key = keyAndValue[0]
        const value = keyAndValue[1].replace(/"(.*)"/g, '$1')
        return {
          ...pre,
          [key]: value,
        }
      }, {})

    const createFrom = () => {
      if (window?.hbspt) {
        // eslint-disable-next-line no-undef
        hbspt.forms.create({
          ...data,
          target: `#hubspot`,
        })
      } else {
        setTimeout(createFrom, 100)
      }
    }

    createFrom()
  }, [html])
}

export { useCreateHbsptForm }

/**
 * 記事中に埋め込まれたPardotフォームタグをHTML文字列に変換し、HTMLに埋め込む
 * ※ フォームタグの形式：[PardotForm formSrc="${URL}"]
 */
const addPardotFormElementHTMLText = (html) => {
  // NOTE: [PardotForm formSrc="${URL}"]の形式で挿入してもHTMLに展開されるとaタグで囲まれてしまうため、その前提で正規表現を組んでいる
  const formSrc = /\[PardotForm formSrc="<a href=".*?".*?>(.*?)"<\/a>\]/.exec(
    html
  )?.[1]
  if (!formSrc) {
    return html
  }

  const htmlWithPardotForm = html.replace(
    /\[PardotForm.*?\]/,
    renderToStaticMarkup(<PardotForm src={formSrc} ssr />)
  )
  return htmlWithPardotForm
}

export { addPardotFormElementHTMLText }

const useQueryStringTag = (location) => {
  const [queryStringTag, setQueryStringTag] = useState()

  useLayoutEffect(() => {
    const { tag } = queryString.parse(location.search)
    setQueryStringTag(tag)
  }, [location.search])

  return queryStringTag
}

export { useQueryStringTag }

const useBlogsFilteredTag = (tag) => {
  const {
    allMarkdownRemark: { group: tagList = [] },
  } = useStaticQuery(graphql`
    query blogsGroupByTags {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/blog/" } }
        sort: { fields: [frontmatter___date], order: DESC }
      ) {
        group(field: frontmatter___tags, limit: 10) {
          fieldValue
          edges {
            node {
              frontmatter {
                title
                tags
                date(formatString: "YYYY.MM.DD")
                thumbnail {
                  childImageSharp {
                    fluid(maxWidth: 400) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
              fields {
                slug
              }
              excerpt(truncate: true)
            }
          }
        }
      }
    }
  `)

  const edges = tagList.find(({ fieldValue }) => fieldValue === tag)?.edges
  if (!edges) {
    return []
  }

  return edges
}

export { useBlogsFilteredTag }
